"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./index.scss");
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const Player_1 = __importDefault(require("./components/Player"));
const dropdown_toggle_1 = require("../components/dropdown-toggle");
const toggleMobileCasinos = () => {
    document.querySelectorAll(".toggle-mobile-casinos").forEach(function (btn) {
        btn.addEventListener("click", dropdown_toggle_1.toggleParent, true);
    });
};
const main = async () => {
    var _a, _b;
    toggleMobileCasinos();
    const rootElement = document.getElementById("video-player");
    if (!rootElement) {
        return;
    }
    const root = client_1.default.createRoot(rootElement);
    const streamType = ((_a = rootElement.dataset.stream_type) !== null && _a !== void 0 ? _a : "unknown");
    const videoData = {
        videoUrl: (_b = rootElement.dataset.src) !== null && _b !== void 0 ? _b : "",
        streamType: streamType,
    };
    root.render((0, jsx_runtime_1.jsx)(react_1.default.StrictMode, { children: (0, jsx_runtime_1.jsx)(Player_1.default, { videoData: videoData }) }));
};
main();
